$(document).ready(function(){
	$.when(
	    $( "#slide_area .main-slide li" ).clone().appendTo( "#slide_area .choice-btn" )
	).done(function(){
		$('.main-slide').slick({
		  infinite: false,
		  fade: true,
		  arrows: true,
		  asNavFor: '.choice-btn',
		  prevArrow: '<div class="slick-prev"></div>',
		  nextArrow: '<div class="slick-next"></div>',
		});
		$('.choice-btn').slick({
		  infinite: false,
		  variableWidth: true,
		  focusOnSelect: true,
		  arrows: false,
		  asNavFor: '.main-slide',
		});

	;});
      $( "#slide_area .main-slide li" ).each(function(){
        alt = $(this).find('img').attr('alt');
        if(alt){
          $(this).append('<p class="caption" style="text-align: center;">' + alt + '</p>');
        }
      });

	
	
});